import React from 'react';
import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

export default function ScreenLoader() {
  const { isLoading } = useSelector((state) => state.loader);

  return (
    <Backdrop
      open={isLoading}
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
